var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row mb-6"},[_vm._m(0),_c('div',{staticClass:"vx-col sm:w-4/5 w-full"},[_c('vs-input',{attrs:{"placeholder":"Voucher name"},model:{value:(_vm.voucherName),callback:function ($$v) {_vm.voucherName=$$v},expression:"voucherName"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-col sm:w-1/5 w-full"},[_c('span',[_vm._v("Voucher name")])])
}]

export { render, staticRenderFns }